import React from "react";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import { ReactComponent as ShieldIcon } from "src/images/shield.svg";
import BrandSafety from "../BrandSafety/BrandSafety";

export default function BrandSafetyButton({
  isAudienceOverPageLimit,
  showBrandSafety,
  toggleBrandSafetyVisibility,
  listId,
  toggleCrisisDetectionModalVisibility,
}) {
  return (
    <div className="brand-safety__wrapper">
      <MaterialTooltip
        center
        content={
          <IDHFormattedMessage
            id="front_available_disable_brand_safety_over_limit_tooltip"
            defaultMessage="Available only under 100 selected Creators list."
          />
        }
        contentHidden={!isAudienceOverPageLimit}
      >
        <Button
          onClick={toggleBrandSafetyVisibility}
          size="medium"
          variant="white"
          disabled={isAudienceOverPageLimit}
          data-qa="brand-safety-button"
        >
          <ShieldIcon className="icon-left" />
          <IDHFormattedMessage
            id="front_brand_safety_btn"
            defaultMessage="Brand safety"
          />
        </Button>
      </MaterialTooltip>
      {showBrandSafety && (
        <BrandSafety
          listId={listId}
          toggleBrandSafetyVisibility={toggleBrandSafetyVisibility}
          toggleCrisisDetectionModalVisibility={
            toggleCrisisDetectionModalVisibility
          }
        />
      )}
    </div>
  );
}
